
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ChangePassword } from '@/api/user'

interface IResetPasswordData {
  oldPassword: string
  newPassword: string
  confirmPassword: string
}

@Component
export default class ResetPasswordDialog extends Vue {
  @Prop({ default: false }) public visible!: boolean

  public dialogVisible = false
  public loading = false
  public formData: IResetPasswordData = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  }

  // 响应式布局属性
  get dialogWidth() {
    return window.innerWidth < 768 ? '95%' : '30%'
  }

  get formLabelWidth() {
    return window.innerWidth < 768 ? '80px' : '100px'
  }

  public validateSame = (rule:any, value: string, callback: Function) => {
    const newPassword = (this.$refs.newPassword as any).getInput().value
    // const confirmPassword = this.formData.confirmPassword;
    if (newPassword !== value) {
      callback(new Error('两次输入的密码不一致'))
    } else {
      callback()
    }
  }

  public rules = {
    oldPassword: [
      { required: true, message: '请输入原密码', trigger: 'blur' }
    ],
    newPassword: [
      { required: true, message: '请输入新密码', trigger: 'blur' },
      { min: 8, message: '密码长度不能少于8个字符', trigger: 'blur' },
      {
        pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/,
        message: '密码必须包含字母和数字',
        trigger: 'blur'
      }
    ],
    confirmPassword: [
      { required: true, message: '请再次输入新密码', trigger: 'blur' },
      {
        validator: this.validateSame,
        trigger: ['blur', 'change']
      }
    ]
  }


  @Watch('visible')
  onVisibleChange(val: boolean) {
    this.dialogVisible = val
    if (val) {
      this.resetForm()
    }
  }

  @Watch('dialogVisible')
  onDialogVisibleChange(val: boolean) {
    if (!val) {
      this.$emit('update:visible', false)
    }
  }

  public resetForm() {
    this.formData = {
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
    // 重置表单验证
    if (this.$refs.form) {
      (this.$refs.form as any).resetFields()
    }
  }

  public async handleSubmit() {
    try {
      // 添加日志，确认提交时密码值是否正确
      // console.log('提交时的密码值:', {
        // oldPassword: this.formData.oldPassword,
        // newPassword: this.formData.newPassword,
        // confirmPassword: this.formData.confirmPassword
      // });

      const valid = await (this.$refs.form as any).validate()
      if (!valid) return

      this.loading = true
      // 调用修改密码API
      await ChangePassword({
        oldPassword: this.formData.oldPassword,
        newPassword: this.formData.newPassword
      })

      this.$message.success('密码修改成功')
      this.$emit('success')
      this.dialogVisible = false
    } catch (error) {
      console.error('修改密码失败:', error)
      // this.$message.error('修改密码失败，请重试')
    } finally {
      this.loading = false
    }
  }
}
